// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/css/base.scss';
import '@/assets/css/element-variables.scss'
import '@/assets/iconfont/iconfont.css';



import * as filters from './filters'
Vue.use(ElementUI);
Vue.config.productionTip = false

import VueAwesomeSwiper from 'vue-awesome-swiper'
/* 滑动验证码 */
import SlideVerify from 'vue-monoplasty-slide-verify'
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper)
Vue.use(SlideVerify)
import Swiper2, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
Swiper2.use([Navigation, Pagination, EffectFade, Autoplay])

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
// 事件总线
Vue.prototype.$bus = new Vue()



// WEBPACK FOOTER //
// ./src/main.js